import { endOfDay, isWithinInterval, startOfDay } from 'date-fns';

export const isInRange = (start?: string, end?: string, date?: Date): boolean => {
  if (!start || !end || !date) {
    throw new Error('incorrect dates provided');
  }
  const detectDate = startOfDay(new Date(date));
  return isWithinInterval(detectDate, { start: startOfDay(new Date(start)), end: endOfDay(new Date(end)) });
};
